import React from 'react';
import ConsultantVulnerabilitiesPage from './ConsultantVulnerabilitiesPage';

const EnterpriseVulnerabilitiesPage: React.FC = () => {
  return <ConsultantVulnerabilitiesPage scope="enterprise" />;
};

export default EnterpriseVulnerabilitiesPage;

